"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcRotations = exports.calcBoneTransforms = exports.getBonePositions = exports.calcBoneQuaternion = exports.anglesToQuaternion = void 0;
var gl_matrix_1 = require("gl-matrix");
var constants_1 = require("../const/constants");
/**
 * Converts Euler angles into a quaternion
 */
function anglesToQuaternion(angles) {
    var pitch = angles[0];
    var roll = angles[1];
    var yaw = angles[2];
    // FIXME: rescale the inputs to 1/2 angle
    var cy = Math.cos(yaw * 0.5);
    var sy = Math.sin(yaw * 0.5);
    var cp = Math.cos(roll * 0.5);
    var sp = Math.sin(roll * 0.5);
    var cr = Math.cos(pitch * 0.5);
    var sr = Math.sin(pitch * 0.5);
    return gl_matrix_1.quat.fromValues(sr * cp * cy - cr * sp * sy, // X
    cr * sp * cy + sr * cp * sy, // Y
    cr * cp * sy - sr * sp * cy, // Z
    cr * cp * cy + sr * sp * sy // W
    );
}
exports.anglesToQuaternion = anglesToQuaternion;
/**
 * Calculates bone angle
 */
var calcBoneQuaternion = function (frame, bone, animOffset, animValues, sequenceIndex, boneIndex, s) {
    var angle1 = gl_matrix_1.vec3.create();
    var angle2 = gl_matrix_1.vec3.create();
    var _loop_1 = function (axis) {
        if (animOffset[axis + 3] == 0) {
            angle2[axis] = angle1[axis] = bone.value[axis + 3]; // default;
        }
        else {
            var getTotal = function (index) { return animValues.get(sequenceIndex, boneIndex, axis + 3, index, 2 /* TOTAL */); };
            var getValue = function (index) { return animValues.get(sequenceIndex, boneIndex, axis + 3, index, 0 /* VALUE */); };
            var getValid = function (index) { return animValues.get(sequenceIndex, boneIndex, axis + 3, index, 1 /* VALID */); };
            var i = 0;
            var k = frame;
            while (getTotal(i) <= k) {
                k -= getTotal(i);
                i += getValid(i) + 1;
            }
            // Bah, missing blend!
            if (getValid(i) > k) {
                angle1[axis] = getValue(i + k + 1);
                if (getValid(i) > k + 1) {
                    angle2[axis] = getValue(i + k + 2);
                }
                else {
                    if (getTotal(i) > k + 1) {
                        angle2[axis] = angle1[axis];
                    }
                    else {
                        angle2[axis] = getValue(i + getValid(i) + 2);
                    }
                }
            }
            else {
                angle1[axis] = getValue(i + getValid(i));
                if (getTotal(i) > k + 1) {
                    angle2[axis] = angle1[axis];
                }
                else {
                    angle2[axis] = getValue(i + getValid(i) + 2);
                }
            }
            angle1[axis] = bone.value[axis + 3] + angle1[axis] * bone.scale[axis + 3];
            angle2[axis] = bone.value[axis + 3] + angle2[axis] * bone.scale[axis + 3];
        }
    };
    for (var axis = 0; axis < 3; axis++) {
        _loop_1(axis);
    }
    if (gl_matrix_1.vec3.equals(angle1, angle2)) {
        return anglesToQuaternion(angle1);
    }
    var q1 = anglesToQuaternion(angle1);
    var q2 = anglesToQuaternion(angle2);
    return gl_matrix_1.quat.slerp(gl_matrix_1.quat.create(), q1, q2, s);
};
exports.calcBoneQuaternion = calcBoneQuaternion;
/**
 * Returns bone positions
 */
var getBonePositions = function (frame, bone, animOffset, animValues, sequenceIndex, boneIndex, 
// TODO: Do something about it
s) {
    // List of bone positions
    var position = gl_matrix_1.vec3.create();
    var _loop_2 = function (axis) {
        position[axis] = bone.value[axis]; // default;
        if (animOffset[axis] !== 0) {
            var getTotal = function (index) { return animValues.get(sequenceIndex, boneIndex, axis, index, 2 /* TOTAL */); };
            var getValue = function (index) { return animValues.get(sequenceIndex, boneIndex, axis, index, 0 /* VALUE */); };
            var getValid = function (index) { return animValues.get(sequenceIndex, boneIndex, axis, index, 1 /* VALID */); };
            var i = 0;
            var k = frame;
            while (getTotal(i) <= k) {
                k -= getTotal(i);
                i += getValid(i) + 1;
            }
            if (getValid(i) > k) {
                if (getValid(i) > k + 1) {
                    position[axis] += (getValue(i + k + 1) * (1 - s) + s * getValue(i + k + 2)) * bone.scale[axis];
                }
                else {
                    position[axis] += getValue(i + k + 1) * bone.scale[axis];
                }
            }
            else if (getTotal(i) <= k + 1) {
                position[axis] += (getValue(i + getValid(i)) * (1 - s) + s * getValue(i + getValid(i) + 2)) * bone.scale[axis];
            }
            else {
                position[axis] += getValue(i + getValid(i)) * bone.scale[axis];
            }
        }
    };
    for (var axis = 0; axis < 3; axis++) {
        _loop_2(axis);
    }
    return position;
};
exports.getBonePositions = getBonePositions;
/**
 * Calculates bone transforms
 */
var calcBoneTransforms = function (quaternions, positions, bones) {
    var boneTransforms = [];
    for (var i = 0; i < bones.length; i++) {
        var boneMatrix = gl_matrix_1.mat4.fromQuat(gl_matrix_1.mat4.create(), quaternions[i]);
        for (var j = 0; j < 3; j++) {
            // 4 — vector size, 3 + j — index in quat
            boneMatrix[4 * 3 + j] = positions[i][j];
        }
        if (bones[i].parent === -1) {
            // Root bone
            boneTransforms.push(boneMatrix);
        }
        else {
            boneTransforms.push(gl_matrix_1.mat4.multiply(gl_matrix_1.mat4.create(), boneTransforms[bones[i].parent], boneMatrix));
        }
    }
    return boneTransforms;
};
exports.calcBoneTransforms = calcBoneTransforms;
var calcRotations = function (modelData, sequenceIndex, frame, 
// TODO: Do something about it
s) {
    if (s === void 0) { s = 0; }
    var boneQuaternions = modelData.bones.map(function (_, boneIndex) {
        return (0, exports.calcBoneQuaternion)(frame, modelData.bones[boneIndex], modelData.animations[sequenceIndex][boneIndex].offset, modelData.animValues, sequenceIndex, boneIndex, s);
    });
    var bonesPositions = modelData.bones.map(function (_, boneIndex) {
        return (0, exports.getBonePositions)(frame, modelData.bones[boneIndex], modelData.animations[sequenceIndex][boneIndex].offset, modelData.animValues, sequenceIndex, boneIndex, s);
    });
    for (var _i = 0, _a = [constants_1.MOTION_X, constants_1.MOTION_X, constants_1.MOTION_Z]; _i < _a.length; _i++) {
        var axis = _a[_i];
        if (modelData.sequences[sequenceIndex].motionType & axis) {
            bonesPositions[modelData.sequences[sequenceIndex].motionBone][1] = 0;
        }
    }
    return (0, exports.calcBoneTransforms)(boneQuaternions, bonesPositions, modelData.bones);
};
exports.calcRotations = calcRotations;
